import { GetAccountNotificationsQuery } from '@graphql';

const init = (notifications: GetAccountNotificationsQuery['getAccountNotifications']) => {
  const baseValues = {
    standby: {
      all: {
        push: notifications.standby.all.push.enabled,
        email: notifications.standby.all.email.enabled,
      },
    },
    request: {},
    booking: {},
    event: {},
    feedback: {},
  };

  // init REQUEST values if they exist in notifications
  if ('request' in notifications) {
    if ('friendship' in notifications.request) {
      Object.assign(baseValues.request, {
        friendship: {
          email: notifications.request.friendship.email.enabled,
          push: notifications.request.friendship.push.enabled,
        },
      });
    }
    if ('message' in notifications.request) {
      Object.assign(baseValues.request, {
        message: {
          email: notifications.request.message.email.enabled,
          push: notifications.request.message.push.enabled,
        },
      });
    }
    if ('mention' in notifications.request) {
      Object.assign(baseValues.request, {
        mention: {
          email: notifications.request.mention.email.enabled,
          push: notifications.request.mention.push.enabled,
        },
      });
    }
  }

  // init BOOKING values if they exist in notifications
  if ('booking' in notifications) {
    if ('new' in notifications.booking) {
      Object.assign(baseValues.booking, {
        new: {
          email: notifications.booking.new.email.enabled,
          push: notifications.booking.new.push.enabled,
        },
      });
    }
    if ('update' in notifications.booking) {
      Object.assign(baseValues.booking, {
        update: {
          email: notifications.booking.update.email.enabled,
          push: notifications.booking.update.push.enabled,
        },
      });
    }
    if ('late' in notifications.booking) {
      Object.assign(baseValues.booking, {
        late: {
          email: notifications.booking.late.email.enabled,
          push: notifications.booking.late.push.enabled,
        },
      });
    }
    if ('message' in notifications.booking) {
      Object.assign(baseValues.booking, {
        message: {
          email: notifications.booking.message.email.enabled,
          push: notifications.booking.message.push.enabled,
        },
      });
    }
  }

  // init EVENT values if they exist in notifications
  if ('event' in notifications) {
    if ('invitation' in notifications.event) {
      Object.assign(baseValues.event, {
        invitation: {
          email: notifications.event.invitation.email.enabled,
          push: notifications.event.invitation.push.enabled,
        },
      });
    }
    if ('update' in notifications.event) {
      Object.assign(baseValues.event, {
        update: {
          email: notifications.event.update.email.enabled,
          push: notifications.event.update.push.enabled,
        },
      });
    }
    if ('upcoming' in notifications.event) {
      Object.assign(baseValues.event, {
        upcoming: {
          email: notifications.event.upcoming.email.enabled,
          push: notifications.event.upcoming.push.enabled,
        },
      });
    }
  }

  // init FEEDBACK values if they exist in notifications
  if ('feedback' in notifications) {
    if ('new' in notifications.feedback) {
      Object.assign(baseValues.feedback, {
        new: {
          email: notifications.feedback.new.email.enabled,
          push: notifications.feedback.new.push.enabled,
        },
      });
    }
  }

  return baseValues;
};

export default init;
